import styled from 'styled-components';

const Profiletext = styled.div`
    color:black;
    font-size:20px;
    font-family: 'Ubuntu', sans-serif;
    display:inline;
    margin-left:10px;

    @media (max-width: 768px) {
        font-size:13px;
    }
`

export default Profiletext;